/* TOMAPREÇO 1.1 · núcleo JS (COMPARTILHADO — dono: pane de tema principal)
 * Sem dependências. Expõe window.TP com: money(), toast(), drawer.open/close, cart.add/get, fav.*
 * Eventos: 'tp:cart:updated' {detail:{cart, added}}  ·  'tp:fav:changed' {detail:{handles}}
 */
(function () {
  'use strict';
  if (window.TP) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = {};
  try { cfg = JSON.parse(($('#tp-config') || {}).textContent || '{}'); } catch (e) {}

  /* ---------- dinheiro (formato da loja) ---------- */
  function money(cents) {
    var fmt = cfg.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    var n = (Number(cents) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    var intDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var intComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return intDot + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return intDot;
      if (k === 'amount_no_decimals') return intComma;
      return intComma + '.' + parts[1];
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- toast ---------- */
  var toastT;
  function toast(html, ms) {
    var el = $('[data-tp-toast]'); if (!el) return;
    el.innerHTML = html; el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-on'); }, ms || 3500);
  }

  /* ---------- drawers (<dialog>) ---------- */
  var lastFocus = null;
  function open(id) {
    var d = document.getElementById(id); if (!d) return;
    $$('dialog[open][data-tp-drawer]').forEach(function (o) { if (o !== d) o.close(); });
    lastFocus = document.activeElement;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    d.dispatchEvent(new CustomEvent('tp:drawer:open', { bubbles: true }));
  }
  function close(d) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    if (d.open && typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tp-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-tp-open')); return; }
    var c = e.target.closest('[data-tp-close]');
    if (c) { close(c.closest('dialog')); return; }
    if (e.target.matches && e.target.matches('dialog[data-tp-drawer]')) close(e.target); // clique no backdrop
  });
  $$('dialog[data-tp-drawer]').forEach(function (d) {
    d.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    });
  });

  /* ---------- carrinho (núcleo) ---------- */
  function updateCounts(count) {
    $$('[data-tp-cart-count]').forEach(function (b) { b.textContent = count; b.setAttribute('data-count', count); });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function add(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Não foi possível adicionar.'); err.data = j; throw err; }
        return j;
      });
    }).then(function (added) {
      return getCart().then(function (cart) {
        updateCounts(cart.item_count);
        document.dispatchEvent(new CustomEvent('tp:cart:updated', { detail: { cart: cart, added: added } }));
        return { cart: cart, added: added };
      });
    });
  }
  // fallback quando o módulo de mini-carrinho (tp-cart.js) não estiver carregado
  document.addEventListener('tp:cart:updated', function (e) {
    if (window.TP && TP.miniCart) return;
    if (e.detail && e.detail.added) toast('Produto adicionado ao carrinho. <a href="' + (cfg.cartUrl || '/cart') + '" style="text-decoration:underline;font-weight:700">Ver carrinho</a>');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tp-add]'); if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    add([{ id: Number(b.getAttribute('data-tp-add')), quantity: 1 }])
      .catch(function (err) { toast(esc(err.message)); })
      .then(function () { b.removeAttribute('aria-busy'); });
  });

  /* ---------- favoritos (localStorage, por handle) ---------- */
  var FKEY = 'tp_favs';
  function favList() { try { return JSON.parse(localStorage.getItem(FKEY) || '[]'); } catch (e) { return []; } }
  function favSave(l) { try { localStorage.setItem(FKEY, JSON.stringify(l.slice(0, 60))); } catch (e) {} syncFav(); document.dispatchEvent(new CustomEvent('tp:fav:changed', { detail: { handles: l } })); }
  function syncFav() {
    var l = favList();
    $$('[data-tp-fav]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-tp-fav')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-tp-fav-count]').forEach(function (b) { b.textContent = l.length; b.setAttribute('data-count', l.length); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tp-fav]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-tp-fav'), l = favList(), i = l.indexOf(h);
    if (i > -1) { l.splice(i, 1); toast('Removido dos favoritos'); } else { l.unshift(h); toast('Salvo nos favoritos'); }
    favSave(l);
  });
  function renderFavs() {
    var body = $('[data-tp-favs-body]'); if (!body) return;
    var l = favList();
    if (!l.length) { body.innerHTML = '<div class="tp-empty"><svg class="tp-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 1 0-7.1 7.1L12 21.5l8.8-8.8a5 5 0 0 0 0-7.1z"/></svg><p>Você ainda não salvou nenhum produto.</p><p>Toque no coração dos produtos para guardar aqui.</p></div>'; return; }
    body.innerHTML = '<div class="tp-skel" style="height:80px;margin:16px"></div>';
    Promise.all(l.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var live = ps.filter(Boolean);
      body.innerHTML = live.map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=144';
        return '<div class="tp-mcart__item"><a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>'
          + '<div><a class="tp-mcart__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
          + '<div class="tp-mcart__row"><span class="tp-mcart__price">' + money(p.price) + '</span>'
          + '<button type="button" class="tp-btn tp-btn--ghost tp-btn--sm" data-tp-fav="' + esc(p.handle) + '" aria-pressed="true">Remover</button></div></div></div>';
      }).join('') || '<div class="tp-empty"><p>Os produtos salvos não estão mais disponíveis.</p></div>';
    });
  }
  document.addEventListener('tp:drawer:open', function (e) { if (e.target.id === 'tp-favs') renderFavs(); });
  document.addEventListener('tp:fav:changed', function () { var d = document.getElementById('tp-favs'); if (d && d.open) renderFavs(); });

  /* ---------- 2ª foto do card: só baixa no primeiro hover (mobile não baixa) ---------- */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.tp-card'); if (!card) return;
    var im = card.querySelector('img[data-tp-hover-src]'); if (!im) return;
    im.srcset = im.getAttribute('data-tp-hover-srcset'); im.src = im.getAttribute('data-tp-hover-src');
    im.removeAttribute('data-tp-hover-src');
  }, { passive: true });

  /* ---------- carrosséis horizontais ---------- */
  function initScrollers(root) {
    $$('[data-tp-scroller]', root).forEach(function (s) {
      if (s.__tp) return; s.__tp = true;
      var track = $('.tp-scroller__track', s), prev = $('.tp-scroller__btn--prev', s), next = $('.tp-scroller__btn--next', s);
      if (!track) return;
      var upd = function () {
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* ---------- busca pelo bottom nav ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-tp-focus-search]')) return;
    var i = $('.tp-search__input'); if (!i) { location.href = cfg.searchUrl || '/search'; return; }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () { i.focus(); }, 250);
  });

  window.TP = { cfg: cfg, money: money, esc: esc, toast: toast, drawer: { open: open, close: close }, cart: { add: add, get: getCart, updateCounts: updateCounts }, fav: { list: favList, sync: syncFav }, initScrollers: initScrollers, $: $, $$: $$ };

  function footCols() {
    var mq = window.matchMedia("(min-width: 990px)");
    var set = function () { $$("[data-tp-footcol]").forEach(function (d) { if (mq.matches) d.setAttribute("open", ""); else d.removeAttribute("open"); }); };
    set(); if (mq.addEventListener) mq.addEventListener("change", set);
  }
  function init() { syncFav(); initScrollers(document); footCols(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initScrollers(e.target); syncFav(); });
})();
